const aesjs = require('aes-js')

export const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  )
}

export const numToCurrency = (num) => {
  try {
    num = num.toLocaleString('en')
  } catch (e) {}
  return num
}

export const copyToClipboard = (text) => {
  try {
    setTimeout(async () => await navigator.clipboard.writeText(text))
  } catch (err) {
    const copyText = document.createElement('textarea')
    document.body.appendChild(copyText)
    copyText.value = text
    copyText.select()
    copyText.setSelectionRange(0, 99999) /* For mobile devices */
    document.execCommand('copy')
    copyText.remove()
  }
}

/**
 * 下載檔案
 * @param {*} dataUrl
 * @param {*} filename 若不指定副檔名，會自動偵測
 */
export const downloadFile = (dataUrl, fileName) => {
  const a = document.createElement('a')
  a.href = dataUrl
  a.download = fileName
  a.target = '_blank'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

/**
 * 下載 Canvas 並存成圖片
 * @param {*} canvasEl
 * @param {*} fileName 若不指定副檔名，會自動偵測
 */
export const downloadCanvasAsImage = (canvasEl, fileName) => {
  downloadFile(canvasEl.toDataURL(), fileName)
}

export const convertContactAddress = (contactAddress) => {
  const source = { ...contactAddress } // clone
  const fields = [
    'district',
    'village',
    'road',
    'lane',
    'alley',
    'number',
    'suffixNumber',
    'subNumber',
    'floor',
    'suffixFloorNumber',
    'unitNumber',
  ]
  // set null & undefined to empty string
  fields.forEach((field) => {
    source[field] = source[field] || ''
  })
  let number = source.number
  if (number) {
    number += source.suffixNumber && `-${source.suffixNumber}`
    number += source.subNumber ? `號之${source.subNumber}` : '號'
  }
  let floor = source.floor
  if (floor) {
    floor += source.suffixFloorNumber && `-${source.suffixFloorNumber}`
    floor += source.unitNumber ? `樓之${source.unitNumber}` : '樓'
  }
  return {
    county: source.county,
    district: source.district,
    details:
      source.village +
      source.road +
      (source.lane ? source.lane + '巷' : '') +
      (source.alley ? source.alley + '弄' : '') +
      number +
      floor,
  }
}

export const isAddressValidRegionForRelocationService = (
  address,
  validRegions
) => {
  const region = validRegions.find(
    (region) => region.county === address?.county
  )
  const countyValid = !!region
  const districtValid =
    !region?.districts?.length ||
    region?.districts?.find((district) => district === address?.district)
  return countyValid && districtValid
}

export const hasVenderAboutContent = (aboutData) =>
  Boolean(
    aboutData?.introduction?.content?.trim() ||
      aboutData?.achievements?.length ||
      aboutData?.teamMembers?.length ||
      aboutData?.certifications?.length ||
      aboutData?.licenses?.length
  )

//用AES的CBC模式加密並輸出十六進位格式
export const encodeByAESCBC = async (value) => {
  try {
    const res = await fetch(
      `/api/encodebyaescbc?value=${encodeURIComponent(value)}`
    )
    const { encryptedHex } = await res.json()
    return encryptedHex
  } catch (error) {
    console.error('encodeByAESCBC error', error)
    return null
  }
}

// 建立一個較安全的 URI 解碼函式
export const safeDecodeURIComponent = (value) => {
  if (!value) return ''
  try {
    return decodeURIComponent(value)
  } catch (e) {
    // 若解碼失敗（e.g. 遇到無效的 '%' 字元）則直接使用原始 value 進行後續處理
    if (e instanceof URIError) {
      return value // 解碼失敗時，回傳原始值
    }
    throw e
  }
}
